var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "list",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.221,
    height: 23.285,
    viewBox: "0 0 29.221 23.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M8.062,52H1.983A1.985,1.985,0,0,0,0,53.983v6.079a1.985,1.985,0,0,0,1.983,1.983H8.062a1.985,1.985,0,0,0,1.983-1.983V53.983A1.985,1.985,0,0,0,8.062,52Z",
    transform: "translate(0 -52)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M8.062,284H1.983A1.985,1.985,0,0,0,0,285.983v6.079a1.985,1.985,0,0,0,1.983,1.983H8.062a1.985,1.985,0,0,0,1.983-1.983v-6.079A1.985,1.985,0,0,0,8.062,284Z",
    transform: "translate(0 -270.759)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M239.524,101.826h-14.61a.913.913,0,0,1,0-1.826h14.61a.913.913,0,0,1,0,1.826Z",
    transform: "translate(-211.216 -97.261)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M234.5,161.826h-9.588a.913.913,0,0,1,0-1.826H234.5a.913.913,0,0,1,0,1.826Z",
    transform: "translate(-211.216 -153.836)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M239.524,329.826h-14.61a.913.913,0,0,1,0-1.826h14.61a.913.913,0,0,1,0,1.826Z",
    transform: "translate(-211.216 -312.248)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M234.5,393.826h-9.588a.913.913,0,0,1,0-1.826H234.5a.913.913,0,0,1,0,1.826Z",
    transform: "translate(-211.216 -372.596)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b9d53670.svg";
export { ForwardRef as ReactComponent };